// extracted by mini-css-extract-plugin
export default {"Card":"DashboardCard_Card__A587i","iconCard":"DashboardCard_iconCard__So4FJ"};